module.exports = "<ng-template>\n    <ng-content></ng-content>\n</ng-template>\n<ng-template [ngTemplateOutlet]=\"template\"></ng-template>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/printer/printer.component.html
// module id = ../../../../../../../../../../digicerba-common-module/src/components/printer/printer.component.html
// module chunks = 0